/**
 * `read_guide` for this editor's MCP server: the guides are the gateway's (the `editor.guides` kit), and arrive in
 * the kit manifest (`kits.ts`) as the text the tool returns. In a hosted session the gateway answers `read_guide`
 * itself, and forwards the guides read to the specialists.
 */

import { getKitManifest } from '../kits';
import type { ToolDefinition } from './types';

export const guideTools: ToolDefinition[] = [{
    tool: { name: 'read_guide', input_schema: { type: 'object', properties: { name: { type: 'string' } }, required: ['name'] } },
    execute: async (input) => {
        const guides = getKitManifest()?.guides ?? {};
        const name = String(input.name);
        if (!Object.hasOwn(guides, name)) return `Error: No guide named ${JSON.stringify(input.name)}. Guides: ${Object.keys(guides).join(', ') || 'none'}.`;
        return guides[name];
    },
}];
